import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAssignmentByVideoId: builder.query({
			query: (videoId) => `/assignments?video_id=${videoId}`,
		}),
		getAssignment: builder.query({
			query: (assignmentId) => `/assignments/${assignmentId}`
		}),
		getAssignments: builder.query({
			query: () => "/assignments"
		}),
		editAssignment: builder.mutation({
			query: ({ id, data }) => ({
				url: `/assignments/${id}`,
				method: "PUT",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getAssignments",
							undefined,
							(draft) => {
								let indexToUpdate = draft.findIndex(
									(assignment) => assignment.id == arg.id
								);
								if (indexToUpdate !== -1) {
									draft[indexToUpdate] = result.data;
								}
							}
						)
					);

					dispatch(
						apiSlice.util.updateQueryData(
							"getAssignment",
							arg.id.toString(),
							(draft) => {
								Object.assign(draft, result.data);
							}
						)
					);
				}
			},
		}),
		deleteAssignment: builder.mutation({
			query: (id) => ({
				url: `/assignments/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(id, { queryFulfilled, dispatch }) {
				// delete optismatically
				const patchResult = dispatch(
					apiSlice.util.updateQueryData(
						"getAssignments",
						undefined,
						(draft) => {
							const indexToDelete = draft.findIndex(
								(assignment) => assignment.id == id
							);
							if (indexToDelete !== -1) {
								draft.splice(indexToDelete, 1);
							}
						}
					)
				);

				try {
					await queryFulfilled;
				} catch (error) {
					patchResult.undo();
				}
			},
		}),
		addAssignment: builder.mutation({
			query: (data) => ({
				url: "/assignments",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getAssignments",
							undefined,
							(draft) => {
								draft.push(result.data);
							}
						)
					);
				}
			},
		}),
	}),
});

export const { 
	useGetAssignmentQuery,
	useGetAssignmentByVideoIdQuery,
	useGetAssignmentsQuery,
	useEditAssignmentMutation,
	useDeleteAssignmentMutation,
	useAddAssignmentMutation
} = assignmentApi;
